// TO USE IT:
// all function
// import * as timeUtils from '../utils/LocationUtils';

// one function
// import { fetchAllLocation } from '../utils/LocationUtils.js';

import { axiosInstance } from './axiosInterceptor.js';
const apiUrl = process.env.REACT_APP_API_URL;
const mainLoc = process.env.REACT_APP_MAINLOC;

export const fetchAllLocation = (setLocationData = null) => {
    setTimeout(async () => {
        try {
            const response = await axiosInstance.get(`${apiUrl}/api/getAllLocationCode`);
            const locations = response.data;
            // console.log(locations)
            const locationCodes = Object.values(locations).map(location => location.LocationCode).join(',');
            localStorage.setItem('locationCodes', locationCodes);
            if (setLocationData) setLocationData(locations);
            return locations;
        } catch (error) {
            console.error('Error fetching location data:', error);
        }
    }, 0);
};

export const getRelativeLocationName = (locationCode) => {
    switch (locationCode) {
        case null: return 'Toronto';
        case "XYZ": return 'North York';
        case "PAT": return 'Toronto';
        case "PAM": return 'Mississauga';
        case undefined: return 'Undefined';
        default: return String(locationCode);
    }
};

export const getProcessedStorageToStorage = (locationCode, defaultReturn = mainLoc) => {
    switch (locationCode) {
        case "PAT": return 'PAT';
        case "XYZ": return 'XYZ';
        case "PAM": return 'PAM';
        case null:
            console.error("No locationCode. Please Login.");
            return "Please Login";
        default: return defaultReturn;
    }
}

export const isDisplayingMainLocation = (locationCode) => {
    switch (locationCode) {
        case null: return true;
        case "XYZ": return true;
        case "PAT": return true;
        default: return false;
    }
};